// src/services/acceso.service.js
// Cliente del módulo "Acceso" (solo administrador CX).
// Los endpoints validan rol=admin en el query string; aquí se fija siempre.
import { apiGet, apiPost, apiPut, apiDelete } from "./api";

const Q = "?rol=admin";

export const accesoService = {
  // Lista de asignaciones (colaborador -> cuenta/área) con nombres resueltos.
  async fetchAcceso() {
    const data = await apiGet("/acceso" + Q);
    return (data && data.items) || [];
  },

  // Catálogos para los <select>: { colaboradores, cuentas, areas }.
  async fetchCatalogos() {
    return apiGet("/acceso/catalogos" + Q);
  },

  // Asigna una cuenta o un área a un colaborador.
  // body: { idColaborador, tipo: 'CUENTA'|'AREA', idCuenta?, idArea? }
  async asignar(body) {
    const resp = await apiPost("/acceso" + Q, body);
    if (!resp || Number(resp.ERROR_ID) !== 200) {
      throw new Error((resp && resp.MENSAJE) || "No se pudo asignar el acceso.");
    }
    return resp;
  },

  // Retira una asignación (borrado lógico).
  async quitar(idAcceso) {
    const resp = await apiDelete("/acceso/" + encodeURIComponent(idAcceso) + Q);
    if (!resp || Number(resp.ERROR_ID) !== 200) {
      throw new Error((resp && resp.MENSAJE) || "No se pudo quitar el acceso.");
    }
    return resp;
  },

  // Fija el ROL global de un colaborador.
  async setRol(idColaborador, rol) {
    const resp = await apiPut(
      "/colaboradores/" + encodeURIComponent(idColaborador) + "/rol" + Q,
      { rol }
    );
    if (!resp || Number(resp.ERROR_ID) !== 200) {
      throw new Error((resp && resp.MENSAJE) || "No se pudo actualizar el rol.");
    }
    return resp;
  },
};

export default accesoService;
